import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getProduct, updateProduct } from 'redux/actions/products'
import Page from 'components/Page'
import ProductForm from 'components/forms/ProductForm'
import { useNavigate, useParams } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import { uploadBulkFiles } from '../../../api/files'
import { message } from 'antd'

const ProductsView = () => {
  const dispatch = useDispatch()
  const { item: product, isGetLoading, isChangeLoading } = useSelector((state) => state.products)
  const { id } = useParams()
  const navigate = useNavigate()

  const uploadBulkFilesMutation = useMutation(
    ({ files, onProgress }) => uploadBulkFiles(files, { onProgress }),
    {
    onError: (err) => {
      message.error('Failed to upload images')
    },
  })

  useEffect(() => {
    dispatch(getProduct({ id }))
  }, [dispatch, id])

  const submitHandler = async (
    id,
    {
      title,
      arabianTitle,
      shortName,
      shortNameArabian,
      packName,
      packNameArabian,
      about,
      aboutArabian,
      isVisible,
      isFeatured,
      oldPrice,
      volume,
      loyaltyPointsEnabled,
      extraLoyaltyPoints,
      images,
    },
  ) => {
    let finalImages = []

    if (images && images.length > 0) {
      const newFiles = images.filter((img) => img.file)
      const existingImages = images.filter((img) => !img.file)

      let uploadedImages = []
      if (newFiles.length > 0) {
        try {
          const progressKey = 'product-images-upload-progress'
          const entities = await uploadBulkFilesMutation.mutateAsync({
            files: newFiles.map((img) => img.file),
            onProgress: (percent) => {
              message.open({
                key: progressKey,
                type: 'loading',
                duration: 0,
                content: `Uploading images... ${percent}%`,
              })
            },
          })
          message.destroy(progressKey)
          uploadedImages = entities.map((entity, index) => ({
            id: entity.id,
            isDefault: newFiles[index].isDefault,
          }))
        } catch (error) {
          message.destroy('product-images-upload-progress')
          console.error('Upload failed', error)
          return // Stop submission
        }
      }

      finalImages = [
        ...existingImages.map((img) => ({ id: img.id, isDefault: img.isDefault })),
        ...uploadedImages,
      ]
    }

    dispatch(
      updateProduct({
        id,
        data: {
          title,
          arabianTitle,
          shortName,
          shortNameArabian,
          packName,
          packNameArabian,
          about,
          aboutArabian,
          isVisible,
          isFeatured,
          oldPrice,
          volume,
          loyaltyPointsEnabled,
          extraLoyaltyPoints,
          images: finalImages.length > 0 ? finalImages : undefined,
        },
        navigate,
      }),
    )
  }

  useEffect(() => {
    if (product) {
     // console.log('Product data:', product)
      //console.log('Product images:', product.productImages)
      //console.log('Product image:', product.image)
    }
  }, [product])

  return (
    <Page pageTitle={product.title} isGetLoading={isGetLoading} isChangeLoading={isChangeLoading}>
      <ProductForm
        defaultValues={product}
        submitHandler={(data) => submitHandler(id, data)}
        loading={isChangeLoading || uploadBulkFilesMutation.isLoading}
      />
    </Page>
  )
}

export default ProductsView
